import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { List } from '../../common/components';
import { AvatarComponent } from '../../people/components';
import { partial } from '../../../utils';

const StyledList = styled(List)`
  //width: ${props => (props.breakpoint !== 'phone' ? 85 : 100)}%;
  width: ${props => (props.breakpoint === 'desktop' ? 80 : 100)}%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  //margin: 0 auto;
  margin: 0 ${props => (props.breakpoint === 'tablet' ? '1.875rem' : 'auto')};

  > div {
    //margin: 0 ${props =>
      props.breakpoint !== 'phone' ? '1.875rem' : 0} 2rem;
    //width: ${props =>
      props.breakpoint !== 'phone' ? 13.2827324478178 : 100}%;

    margin: 0 0 2rem;
    //margin: 0;
    width: ${props => (props.breakpoint !== 'phone' ? 20 : 100)}%;

    ${props =>
      props.breakpoint !== 'phone' &&
      `
      > figure {
        width: 70.5645161290323%;
        padding-top: 70.5645161290323%;
      }
    `}
  }
`;

class PeopleList extends Component {
  static propTypes = {
    breakpoint: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    onClick: PropTypes.func,
  };

  renderItem = (item, index) => {
    const { breakpoint, onClick } = this.props;
    const { slug, image, firstName, nationality, tagline } = item;
    const onAvatarClick = partial(onClick, slug);
    return (
      <AvatarComponent
        layout={breakpoint === 'phone' ? 'row' : 'column'}
        key={index}
        onClick={onAvatarClick}
        imageSrc={image}
        firstName={firstName}
        nationality={nationality}
        tagLine={tagline}
      />
    );
  };

  render() {
    const { breakpoint, items } = this.props;
    if (!items || items.length === 0) {
      return null;
    }

    return (
      <StyledList
        breakpoint={breakpoint}
        items={items}
        renderItem={this.renderItem}
      />
    );
  }
}

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps)(PeopleList);



// WEBPACK FOOTER //
// ./src/modules/pages/components/PeopleList.js